module.exports = "/static-assets/_next/static/images/baggy-4a9ed4c1d50e661ef84a8566943123a3.svg";